import { Heading, TypographyColor, TypographyType } from ".";

export const NewFeature = () => {
    return (
        <span className="badge bg-black-1">
            <Heading
                title='NEW'
                type={TypographyType.h7}
                colour={TypographyColor.secondary}
                classname='color-gradient'
            />
        </span>
    );
}